import { mergeClassName as e } from "../../utils/data.js";
import { formatDate as t } from "../../utils/dates.js";
import { Calendar as ee } from "./Calendar.js";
import { useFormField as n } from "../FormField/useFormField.js";
import { FormField as r } from "../FormField/FormField.js";
import { DateFieldPopover as i } from "./DateFieldPopover.js";
import { HiddenDateInput as a } from "./HiddenDateInput.js";
import { useControlledDate as o, useDateEmitter as s, usePopoverOpen as c, useSyncedRef as l } from "./useDateField.js";
import { DateRangeInputTrigger as te } from "./DateRangeInputTrigger.js";
import { useCallback as ne } from "react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { CalendarBlankIcon as f } from "@phosphor-icons/react";
//#region lib/components/DatePicker/DateRangePicker.tsx
function p({ fromValue: p, toValue: m, defaultFromValue: h, defaultToValue: g, fromProps: _, toProps: v, format: y = "iso", onFromChange: b, onToChange: x, onFromValueChange: S, onToValueChange: re, onBlur: C, label: ie, helpText: w, errorMessage: T, fromPlaceholder: E = "From", toPlaceholder: D = "To", disabled: O = !1, required: k, id: A, className: j, picker: M = "days", showFooter: N = !0, presets: P = !0, presetsOrientation: F = "right", numberOfMonths: I = 2, formatDateConfig: L, containerProps: R, inputTriggerProps: z, popoverProps: B, ...V }) {
	let { timeZone: H } = V, { fieldId: U, hasError: W, describedBy: G } = n({
		id: A,
		helpText: w,
		errorMessage: T
	}), K = l(_?.ref), q = l(v?.ref), J = o({
		value: p,
		defaultValue: h,
		format: y,
		timeZone: H
	}), Y = o({
		value: m,
		defaultValue: g,
		format: y,
		timeZone: H
	}), X = s(J.commit, {
		name: _?.name,
		onChange: b,
		onValueChange: S,
		registerOnChange: _?.onChange
	}), Z = s(Y.commit, {
		name: v?.name,
		onChange: x,
		onValueChange: re,
		registerOnChange: v?.onChange
	}), ae = ne(() => {
		C?.({ target: K.current }), _?.onBlur?.({ target: K.current }), v?.onBlur?.({ target: q.current });
	}, [
		K,
		_,
		C,
		q,
		v
	]), { open: Q, handleOpenChange: $ } = c(ae), oe = () => {
		O || $(!0);
	};
	return /* @__PURE__ */ d(r, {
		id: U,
		label: ie,
		helpText: w,
		errorMessage: T,
		containerProps: R,
		children: [
			/* @__PURE__ */ u(i, {
				open: Q,
				onOpenChange: $,
				trigger: /* @__PURE__ */ u(te, {
					hasError: W,
					active: Q,
					disabled: O,
					fromValue: t(J.date, {
						timeZoneDisplay: !1,
						timezone: H,
						...L
					}),
					toValue: t(Y.date, {
						timeZoneDisplay: !1,
						timezone: H,
						...L
					}),
					fromPlaceholder: E,
					toPlaceholder: D,
					prefix: /* @__PURE__ */ u(f, {
						size: 20,
						"aria-hidden": !0
					}),
					describedBy: G,
					id: U,
					onOpen: oe,
					...z,
					className: e(j, z?.className)
				}),
				...B,
				children: /* @__PURE__ */ u(ee, {
					mode: "range",
					value: {
						from: J.date,
						to: Y.date
					},
					numberOfMonths: I,
					presets: P,
					presetsOrientation: F,
					picker: M,
					showFooter: N,
					...V,
					onApply: (e) => {
						N && e && (X(e.from), Z(e.to), $(!1));
					},
					onChange: (e) => {
						!N && e && (X(e.from), Z(e.to));
					},
					onCancel: () => {
						$(!1);
					}
				})
			}),
			/* @__PURE__ */ u(a, {
				ref: K,
				name: _?.name,
				value: J.value,
				format: y,
				timeZone: H,
				required: k
			}),
			/* @__PURE__ */ u(a, {
				ref: q,
				name: v?.name,
				value: Y.value,
				format: y,
				timeZone: H,
				required: k
			})
		]
	});
}
//#endregion
export { p as DateRangePicker };
